var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shared-pricing',{staticClass:"int-video-details"},[_c('div',{staticClass:"int-video-details__data-cont"},[_c('video-service')],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }